import { dateFormatter2 as dateFormatter, DateFormatTypes } from '@jfs/utils'
import { AddressType } from '../../data/models/Address'
export const txnDetailsParserV3 = (data: any, type: any) => {
  const transaction = data?.data?.data?.content[0] ?? {}
  return {
    id: transaction?.transactionId ?? 'NA',
    date: dateFormatter(transaction?.transactionDateTime ?? 'NA', DateFormatTypes.DATE_ONLY), // timestamp
    ern: transaction?.invoice ?? 'NA',
    rrn: transaction?.transactionId ?? 'NA',
    originalTransactionId: transaction?.originalTransactionId ?? '',
    amount: transaction?.transactionAmount ?? 0, // amount as number
    status: transaction?.transactionDisposition ?? 'NA',
    bankRefNumber: transaction?.issRefData ?? 'NA',
    type: transaction?.transactionType ?? 'NA',
    authCode: transaction?.authCode ?? 'NA', // Authorization Code provided by Issuer for a transaction
    acquirerTerminal: transaction?.acquirerTerminal ?? 'NA', // Terminal ID on which the transaction was acquired
    surCharge: transaction?.surChargeAmount ?? 0, // This is like fuel surcharge
    convenienceFeeAmount: transaction?.conFeeAmount ?? 0, // Convenience Fee. IRCTC like merchants don’t bear the MDR. They pass it on to the customer & it is called Convenience Fee
    emiCode: transaction?.emiInd ?? 'NA', // asked
    merchantName: transaction?.merchantName ?? 'NA', // asked
    merchantType: transaction?.merchantType ?? 'NA', // asked
    taxOnConvenienceFee: transaction?.totalTaxOnConvenienceFee ?? 0, // ?
    amtDebitedFromCust: transaction?.amtDebitedFromCust ?? 0, // ?
    transactionClass: transaction?.transactionClass ?? 'NA', // Internal code classification of transactions – like Purchase(WPP), Load Money (LMU/LMW) etc.
    txnType: type,
    failureMessage: transaction?.failureMessage ?? 'NA',
    customer: {
      id: transaction?.customerId ?? 'NA',
      name: transaction?.customerName ?? 'NA',
      mobileNumber: transaction?.mobileNumber ?? 'NA',
      email: transaction?.email ?? 'NA',
      address: {
        id: 'NA',
        type: AddressType.Residential,
        line1: transaction?.addressLine1 ?? 'NA',
        line2: transaction?.addressLine2 ?? 'NA',
        pincode: transaction?.pin ?? 'NA',
        city: 'NA',
        state: transaction?.state ?? 'NA',
        country: 'NA',
      },
    },
    payment: {
      paymentMode: transaction?.cardType ?? 'NA',
      paymentType: transaction?.paymentType ?? 'NA',
      accountNumber: transaction?.accountNumber ?? 'NA',
      cardCountryCode: transaction?.issCountryCode ?? 'NA',
      cardLogoId: transaction?.cardLogoId ?? 'NA',
      offerId: transaction?.offerCode ?? 'NA',
      settlementRefNumber: transaction?.settlementRefNumber ?? 'NA',
      udf1: transaction?.udf1 ?? 'NA',
      udf2: transaction?.udf2 ?? 'NA',
      udf3: transaction?.udf3 ?? 'NA',
      udf4: transaction?.udf4 ?? 'NA',
      udf5: transaction?.udf5 ?? 'NA',
    },
    disputes: {
      chargeBackReasonCode: transaction?.chargeBackReason ?? 'NA',
      chargeBackDate: dateFormatter(transaction?.chargeBackDate ?? 'NA', DateFormatTypes.DATE_AM_PM),
      replyBeforeDate: dateFormatter(transaction?.replyBeforeDate ?? 'NA', DateFormatTypes.DATE_AM_PM),
    },
    offer: {
      merchantOfferRefId: transaction?.merchantOfferRefId ?? 'NA',
      offerKey: transaction?.offerKey ?? 'NA',
      instantDiscountAmount: transaction?.instantDiscountAmount ?? 0,
      instantDiscountStatus: transaction?.instantDiscountStatus ?? 'NA',
      cashBackAmount: transaction?.cashBackAmount ?? 0,
      cashbackStatus: transaction?.cashbackStatus ?? 'NA',
      offerCompolsoryFlag: transaction?.offerCompolsoryFlag ?? false,
      offerTransactionAmount: transaction?.offerTransactionAmount ?? 0,
    },
    refund: {
      amount: transaction?.refundAmount ?? 0,
      pending: transaction?.refundPending ?? 0,
      requestedDate: dateFormatter(transaction?.refundRequestedDate ?? 'NA', DateFormatTypes.DATE_AM_PM),
      processdDate: dateFormatter(transaction?.refundProcessdDate ?? 'NA', DateFormatTypes.DATE_AM_PM),
      status: transaction?.refundStatus ?? 'NA',
      refundMessage: transaction?.refundMessage ?? 'NA',
      processed: '',
      sourceSystem: transaction?.sourceSystem ?? '',
    },
    settlementDetails: {
      referenceNumber: transaction?.settlementRefNumber ?? 'NA',
      status: transaction?.settlementStatus ?? 'NA',
      fileName: transaction?.fileName ?? 'NA',
      neftNumber: transaction?.neftNumber ?? 'NA',
      commisionCharge: transaction?.commissionCharged ?? 0,
      totalTaxOnCommission: transaction?.totalTaxOnCommission ?? 0,
      settledAmount: transaction?.settledAmount ?? 0,
      date: dateFormatter(transaction?.settlementDate ?? 'NA', DateFormatTypes.DATE_ONLY_WITHOUT_TIME),
    },
    refundHistory: transaction.refundHistory?.map((item: any) => ({
      trxAmount: item?.txnAmount ?? 0,
      refundAmount: item?.refundAmount ?? 0,
      initiatedDate: dateFormatter(item?.initiatedDate ?? 'NA', DateFormatTypes.DATE_AM_PM),
      status: item?.status ?? 'NA',
      processedOn: item?.processedOn ?? 'NA',
    })),
    convenienceFee: {
      amount: transaction?.convenienceFee ? transaction?.convenienceFee : '0',
      originalTxnAmt: transaction?.originalTxnAmt ? transaction?.originalTxnAmt : '0',
      cgst: transaction?.convFeeCgst ? transaction?.convFeeCgst : '0',
      sgst: transaction?.convFeeSgst ? transaction?.convFeeSgst : '0',
      igst: transaction?.convFeeIgst ? transaction?.convFeeIgst : '0',
      ugst: transaction?.convFeeUgst ? transaction?.convFeeUgst : '0',
    },
  }
}
